var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import Tooltip from 'components/Tooltip.vue';
import { listInfoSetsAllowedToExport } from '@/clients/info_set';
let SearchExportModalInfosetList = class SearchExportModalInfosetList extends Vue {
    constructor() {
        super(...arguments);
        this.searchTerm = '';
        this.newInfosetName = '';
        this.loadingInfosetItems = false;
        this.currentInfosetPage = 1;
        this.infosetId = '';
        this.createInfosetIsOpen = true;
        this.infosets = [];
    }
    async mounted() {
        this.fetchInfoSetsAllowedToExport();
    }
    async fetchInfoSetsAllowedToExport() {
        this.loadingInfosetItems = true;
        try {
            const response = await listInfoSetsAllowedToExport({
                page: 1,
                query: this.searchTerm,
            });
            this.infosets = response.data;
        }
        catch (e) {
            console.log(e);
        }
        this.loadingInfosetItems = false;
    }
    openCreateInfoset() {
        this.infosetId = '';
        this.newInfosetName = '';
        this.searchTerm = '';
        this.createInfosetIsOpen = !this.createInfosetIsOpen;
        this.selectListItem(null);
        this.createInfoset(null);
    }
    createInfoset(value) {
        this.$emit('createInfoset', value);
    }
    searchInfosets() {
        this.currentInfosetPage = 1;
        this.infosetId = '';
        if (this.$refs.infosetVirtualList)
            this.$refs.infosetVirtualList.refresh(0);
        this.fetchInfoSetsAllowedToExport();
    }
    selectListItem(infoSet) {
        this.$emit('selectListItem', infoSet);
    }
    handleShowInfosetsList() {
        return ((this.infosets && this.infosets.length > 0) || this.loadingInfosetItems);
    }
    enforceMaxChars(newValue, oldValue) {
        if (newValue && newValue.length > 60) {
            this.newInfosetName = newValue.slice(0, 60);
        }
    }
};
__decorate([
    Watch('newInfosetName')
], SearchExportModalInfosetList.prototype, "createInfoset", null);
__decorate([
    Watch('newInfosetName')
], SearchExportModalInfosetList.prototype, "enforceMaxChars", null);
SearchExportModalInfosetList = __decorate([
    Component({
        components: {
            Input,
            Tooltip,
        },
    })
], SearchExportModalInfosetList);
export default SearchExportModalInfosetList;
